import * as React from 'react';
import 'codemirror/theme/monokai.css';
import { TabViewerHorizontal } from '../TabViewer';
import HtmlEditor from "./Html/HtmlEditor";
import TextEmailEditor from './Text/Source/TextEditor';

// MUI -> Arco: the Typography/Grid container wrapper became a plain div. The
// Html/Text tab structure and the Easy Email prop threading (editorDesign,
// easyEmailRef) are unchanged.
export default function EmailEditor(props) {
  const { subject, setSubject, htmlContent, setHtmlContent, editor, setEditor, textContent, setTextContent, editorDesign, easyEmailRef, editorHeight, confirmLink, onFlowLink } = props;

  return (
    <div>
      <TabViewerHorizontal tabs={[
        {
          disabled: false,
          name: "Html",
          component: <HtmlEditor
            editor={editor}
            setEditor={setEditor}
            htmlContent={htmlContent}
            setHtmlContent={setHtmlContent}
            textContent={textContent}
            setTextContent={setTextContent}
            editorDesign={editorDesign}
            easyEmailRef={easyEmailRef}
            editorHeight={editorHeight}
            confirmLink={confirmLink}
            onFlowLink={onFlowLink}
          />
        },
        {
          disabled: false,
          name: "Text",
          component: <TextEmailEditor
            textContent={textContent}
            setTextContent={setTextContent}
          />
        },
      ]}></TabViewerHorizontal>
    </div>
  );
}
